export const compareVersions = (
    a: string | number,
    b: string | number
  ): number => {
    const normalize = (v: string | number) => {
      const str = typeof v === "number" ? v.toString() : v.replace(/^v/, "");
      return str.split(".").map(Number);
    };
  
    const partsA = normalize(a);
    const partsB = normalize(b);
  
    for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
      const partA = partsA[i] || 0;
      const partB = partsB[i] || 0;
      if (partA > partB) return 1;
      if (partA < partB) return -1;
    }
  
    return 0;
  };